import { useTranslation } from 'react-i18next';

import { PersonalizationBlock } from './components/PersonalizationBlock';
import { PersonalizationCard } from './components/PersonalizationCard';
import { RecommendationIntegrationGuide } from './components/RecommendationIntegrationGuide';
// TODO: Search API hidden until rework — re-enable imports below when ready
// import { Search } from './components/Search';
// import { SearchAlternative } from './components/SearchAlternative';
// import { SearchIntegrationGuide } from './components/SearchIntegrationGuide';
import { ShopTheLook } from './components/ShopTheLook';
import { SimilarProducts } from './components/SimilarProducts';
import { VisualMerchandise } from './components/VisualMerchandise';

export function Personalization() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Personalization',
  });

  return (
    <div className="py-8">
      <section className="mb-10">
        <h1 className="text-[42px] tracking-[8.25px]">{t('title')}</h1>
      </section>

      <section className="mb-10">
        <div className="max-w-6xl space-y-6">
          <PersonalizationBlock
            title={t('blocks.recommendation.title')}
            description={t('blocks.recommendation.description')}
          >
            <PersonalizationCard
              title={t('products.similarProducts.title')}
              description={t('products.similarProducts.description')}
            >
              <SimilarProducts />
            </PersonalizationCard>

            <PersonalizationCard
              title={t('products.shopTheLook.title')}
              description={t('products.shopTheLook.description')}
            >
              <ShopTheLook />
            </PersonalizationCard>

            <PersonalizationCard
              title={t('products.visualMerchandise.title')}
              description={t('products.visualMerchandise.description')}
            >
              <VisualMerchandise />
            </PersonalizationCard>

            <PersonalizationCard
              title={t('products.recommendationImplementationGuide.title')}
              description={t(
                'products.recommendationImplementationGuide.description',
              )}
            >
              <RecommendationIntegrationGuide />
            </PersonalizationCard>
          </PersonalizationBlock>

          {/* TODO: Search API hidden until rework — uncomment block below when ready
          <PersonalizationBlock
            title={t('blocks.search.title')}
            description={t('blocks.search.description')}
          >
            <PersonalizationCard
              title={t('products.search.title')}
              description={t('products.search.description')}
            >
              <Search />
            </PersonalizationCard>

            <PersonalizationCard
              title={t('products.searchAlternative.title')}
              description={t('products.searchAlternative.description')}
              hidden
            >
              <SearchAlternative />
            </PersonalizationCard>

            <PersonalizationCard
              title={t('products.searchImplementationGuide.title')}
              description={t('products.searchImplementationGuide.description')}
            >
              <SearchIntegrationGuide />
            </PersonalizationCard>
          </PersonalizationBlock>
          */}
        </div>
      </section>
    </div>
  );
}
